function warn(error) {
    if (process.env.NODE_ENV !== 'production') {
        /* eslint-disable-next-line */
        console.warn(error.message);
        if (error.cause instanceof Error) {
            /* eslint-disable-next-line */
            console.error(error.cause);
        }
    }
}
export default warn;
//# sourceMappingURL=warn.js.map